import Repository from '@/repositories/Repository'
import Summary from '@/models/Summary'

export type SummaryParams = {
  stationId: string
  range: {
    startTime: string
    endTime: string
    type: string
  }
  target: string[]
  threshold?: {
    key: string
    operation: string
    target: string
    comparison_value: number
  }[]
}

export default class SummaryRepository extends Repository {
  constructor() {
    super('/summary')
  }

  async get(params: SummaryParams) {
    const attributes = await super._post<SummaryParams>(params)

    return new Summary(attributes)
  }
}
